<span class="status-label" [ngClass]="{'hide-label': (isMobileApp && !isAIChatSubscriptionActive)}">
  <span class="current-message">{{statusMessage.currentStatus}}</span>
  @if (statusMessage.callToAction && chatScreenConfig?.zendeskChatEnabled) {
    <span class="call-to-action" (click)="onToggle()" [ngClass]="{'disabled': disableToggleButton}">{{statusMessage.callToAction}}</span>
  }
</span>